module.exports = __webpack_public_path__ + "assets/tutorials/Navigating_Test_Results.png";